import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2610e2fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field col-12 px-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "name" }, [
  /*#__PURE__*/_createTextVNode("メニュー名"),
  /*#__PURE__*/_createElementVNode("small", { class: "red-required pl-2" }, "必須")
], -1))
const _hoisted_3 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_4 = { class: "field col-12 px-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "description" }, "メニュー説明", -1))
const _hoisted_6 = { class: "text-gray-500 block" }
const _hoisted_7 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_8 = { class: "field col-12 px-0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createTextVNode("所要時間"),
  /*#__PURE__*/_createElementVNode("small", { class: "red-required pl-2" }, "必須")
], -1))
const _hoisted_10 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_11 = { class: "field col-12 px-0" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "unit-price" }, [
  /*#__PURE__*/_createTextVNode("金額"),
  /*#__PURE__*/_createElementVNode("small", { class: "red-required pl-2" }, "必須")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "円", -1))
const _hoisted_14 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_15 = { class: "field col-12 px-0" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "postion-number" }, [
  /*#__PURE__*/_createTextVNode("順番"),
  /*#__PURE__*/_createElementVNode("small", { class: "red-required pl-2" }, "必須")
], -1))
const _hoisted_17 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_18 = { class: "field col-12 px-0" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { for: "notification-message" }, "通知メッセージ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-gray-600 block mt-1 mb-1" }, "お知らせテンプレートのメニュー通知タグとして使用されます", -1))
const _hoisted_21 = { class: "text-gray-500 block" }
const _hoisted_22 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_23 = { class: "field col-10 px-0" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "image-url" }, "イメージ画像", -1))
const _hoisted_25 = { class: "col-2 w-13rem p-0 cursor-pointer" }
const _hoisted_26 = {
  key: 0,
  class: "relative border-1 surface-border bg-white"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "align-items-center justify-content-center" }
const _hoisted_32 = { class: "flex align-items-center justify-content-center" }
const _hoisted_33 = ["alt", "src"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  class: "block p-error text-sm"
}
const _hoisted_36 = { class: "field col-12 px-0" }
const _hoisted_37 = { class: "flex flex-wrap gap-3" }
const _hoisted_38 = { class: "flex align-items-center radio-wrapper__custom" }
const _hoisted_39 = { class: "flex align-items-center cursor-pointer" }
const _hoisted_40 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon text-xl mr-2"
}
const _hoisted_41 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon text-xl mr-2"
}
const _hoisted_42 = { class: "flex align-items-center radio-wrapper__custom" }
const _hoisted_43 = { class: "flex align-items-center cursor-pointer" }
const _hoisted_44 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon text-xl mr-2"
}
const _hoisted_45 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon text-xl mr-2"
}
const _hoisted_46 = { class: "field col-12 px-0" }
const _hoisted_47 = { class: "flex flex-wrap gap-3" }
const _hoisted_48 = { class: "flex align-items-center radio-wrapper__custom" }
const _hoisted_49 = { class: "flex align-items-center cursor-pointer" }
const _hoisted_50 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon text-xl mr-2"
}
const _hoisted_51 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon text-xl mr-2"
}
const _hoisted_52 = { class: "flex align-items-center radio-wrapper__custom" }
const _hoisted_53 = { class: "flex align-items-center cursor-pointer" }
const _hoisted_54 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon text-xl mr-2"
}
const _hoisted_55 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon text-xl mr-2"
}
const _hoisted_56 = { class: "field col-12 px-0" }
const _hoisted_57 = { class: "flex flex-wrap gap-3" }
const _hoisted_58 = { class: "flex align-items-center radio-wrapper__custom" }
const _hoisted_59 = { class: "flex align-items-center cursor-pointer" }
const _hoisted_60 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon text-xl mr-2"
}
const _hoisted_61 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon text-xl mr-2"
}
const _hoisted_62 = { class: "flex align-items-center radio-wrapper__custom" }
const _hoisted_63 = { class: "flex align-items-center cursor-pointer" }
const _hoisted_64 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon text-xl mr-2"
}
const _hoisted_65 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon text-xl mr-2"
}
const _hoisted_66 = { class: "field col-10 px-0" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "category" }, "カテゴリー", -1))
const _hoisted_68 = { class: "checkbox-list grid grid-nogutter" }
const _hoisted_69 = ["for"]
const _hoisted_70 = { class: "field col-10 px-0" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "medical-option-ids" }, "追加の部屋あり", -1))
const _hoisted_72 = { class: "checkbox-list grid grid-nogutter" }
const _hoisted_73 = ["for"]
const _hoisted_74 = { class: "field col-10 px-0" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "medical-option-ids" }, "追加可能オプション", -1))
const _hoisted_76 = { class: "checkbox-list grid grid-nogutter" }
const _hoisted_77 = ["for"]
const _hoisted_78 = { class: "field col-10 px-0" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "staff-ids" }, "担当施術者", -1))
const _hoisted_80 = { class: "checkbox-list grid grid-nogutter" }
const _hoisted_81 = ["for"]
const _hoisted_82 = { class: "field col-10 px-0" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "staff-ids" }, "複数選択可能", -1))
const _hoisted_84 = { class: "checkbox-list grid grid-nogutter" }
const _hoisted_85 = { class: "pt-2 pb-3 cursor-pointer" }
const _hoisted_86 = ["for"]
const _hoisted_87 = { class: "field col-10 px-0" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "staff-ids" }, "1つ選択可能", -1))
const _hoisted_89 = { class: "checkbox-list grid grid-nogutter" }
const _hoisted_90 = ["for"]
const _hoisted_91 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon text-xl mr-2"
}
const _hoisted_92 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon text-xl mr-2"
}
const _hoisted_93 = { class: "radio-wrapper__custom field-checkbox px-0 col-4" }
const _hoisted_94 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon text-xl mr-2"
}
const _hoisted_95 = {
  key: 1,
  class: "icon-lms icon-lms_radio radio-icon text-xl mr-2"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2" }, "なし", -1))
const _hoisted_97 = { class: "w-full flex justify-content-center text-center flex-row align-items-center text-white mb-6" }

import { inject, onBeforeMount, reactive, ref, withDefaults, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import RadioButton from "primevue/radiobutton";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import { MedicalMenuHourOptions, MedicalMenuMinuteOptions } from "@/clinic/typings/enums/medical-menu";
import {
  IMenu,
  IStaff,
  IMedicalOption,
  ApiMenuShowReq,
  ApiBaseReqParams,
  ApiStaffIndexRes,
  ApiMedicalOptionIndexRes,
  ApiBaseReq,
  ApiMenuSaveReq,
  ApiRoomIndexReq,
} from "@/clinic/typings";
import {
  MenuServices,
  StaffServices,
  MedicalOptionServices,
  MedicalMenuCategoryServices,
  ServiceTagService,
  RoomServices,
} from "@/clinic/services";
import { MaybeRefOrGetter, get, set } from "@vueuse/core";
import { useRouteParams } from "@vueuse/router";
import { AxiosResponse } from "axios";
import { Rule, Rules, ValidateError } from "async-validator";
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import formRules from "./rule";
import * as _ from "lodash";
import { notityErrorMsg } from "@/clinic/utils/notify-utils";
import { VISIBILITY_PUBLIC_STATUS, VISIBILITY_PRIVATE_STATUS } from "@/common/constants/medical.constants.ts";
import { PLACEHOLDER_SELECT } from "@/clinic/typings/constants/clinic";
import FileUpload from "primevue/fileupload";

/**
 * フォームの型定義。編集モードかどうかを管理する。
 * @property {boolean} hasEdit 編集モードかどうかを表す
 */
type IForm = {
  hasEdit: boolean;
};
type IFieldValidator = {
  [key: string]: string;
};

/**
 * バリデーションを初期化する。
 * @param value バリデーション対象の値
 * @param rules バリデーションルール
 * @returns バリデーションインスタンス
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  props: {
    hasEdit: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { hasEdit: boolean };



const toast = useToast();
const route = useRoute();
const router = useRouter();
const clinicId = ref(0);
const menuId = ref(0);
const menu = ref<IMenu>();
const categories = ref([]);

/**
 * メディカルメニューのフォームモデルを管理するリアクティブオブジェクト。
 */
const formModel = reactive({
  id: 0,
  name: "",
  description: "",
  timeUnit: 0,
  hourUnit: "00",
  minuteUnit: "00",
  unitPrice: "",
  bookingType: "normal",
  categoryIds: [] as number[],
  roomIds: [],
  optionIds: [],
  staffIds: [],
  multipleTagIds: [],
  singleTagId: "",
  visibility: VISIBILITY_PUBLIC_STATUS,
  displayPrice: true,
  positionNumber: "0",
  image: "",
  image_url: "",
  notificationMessage: "",
});
const staffs = ref<IStaff[]>([]);
const options = ref<IMedicalOption[]>([]);
const rooms = ref([]);
const singleSelectedTag = ref([]);
const multipleSelectedTag = ref([]);

/**
 * バリデーション用の型定義。
 */
const initValidation = (value: IFieldValidator | any, rules: MaybeRefOrGetter<Record<string, Rule | Rules>>) =>
  useAsyncValidator({ ...value, inputUploadImage }, rules, { validateOption: { suppressWarning: true } });

/**
 * バリデーションを実行する。
 * @param fieldName チェックするフィールド名（省略可）
 * @returns バリデーションが通ればtrue
 */
const validate = async (fieldName?: string): Promise<boolean> => {
  const [value, rules] = fieldName
    ? [{ [fieldName]: formModel[fieldName] }, { [fieldName]: formRules[fieldName] }]
    : [formModel, formRules];
  const { execute } = initValidation(value, rules);
  const { pass: fPass, errorFields: fErrorFields, errors: fErrors } = await execute();
  set(pass, get(fPass));
  set(errorFields, get(fErrorFields));
  set(errors, get(fErrors));
  return get(pass) as boolean;
};
const pass = ref(false);
const errorFields = ref<Record<string, ValidateError[]>>({});
const errors = ref<ValidateError[]>([]);
const formRef = ref<HTMLFormElement | null>(null);
const inputUploadImage = ref();

/**
 * 保存成功時の処理を実行する。
 * @returns void
 */
const onSuccess = () => RouterUtils.goTo(RouterConstants.MENU_ROUTER_NAME);

/**
 * 保存失敗時の処理を実行する。
 * @returns void
 */
const onError = () => notityErrorMsg(toast, "保存に失敗しました。もう一度お試しください");

/**
 * 一覧に戻る処理を実行する。
 * @returns void
 */
const backToList = () => RouterUtils.goTo(RouterConstants.MENU_ROUTER_NAME);

/**
 * メニューを保存する。
 * @returns Promise<void>
 */
const saveModel = async (): Promise<void> => {
  if (!(await validate())) return;

  const formData = new FormData(get(formRef) as unknown as HTMLFormElement);

  // 説明が空文字の場合、nullを設定
  if (formModel.description?.trim() === "") {
    formData.set("description", "");
  }
  // 通知メッセージが空文字の場合、nullを設定
  if (formModel.notificationMessage?.trim() === "") {
    formData.set("notification_message", "");
  }
  // 未選択時の空配列append処理は残す
  const dataArray = Array.from(formData.entries());
  const hasRoomIds = dataArray.some(([key]) => key === "room_ids[]");
  const hasMedicalOptionIds = dataArray.some(([key]) => key === "medical_option_ids[]");
  const hasStaffIds = dataArray.some(([key]) => key === "staff_ids[]");

  if (!hasRoomIds) {
    formData.append("room_ids[]", "");
  }
  if (!hasMedicalOptionIds) {
    formData.append("medical_option_ids[]", "");
  }
  if (!hasStaffIds) {
    formData.append("staff_ids[]", "");
  }

  // 既存のcategory_ids[]を一度削除してから、ユニークな値だけappend
  formData.delete("category_ids[]");
  const uniqueCategoryIds = Array.from(new Set(formModel.categoryIds));
  if (uniqueCategoryIds.length === 0) {
    formData.append("category_ids[]", "");
  } else {
    uniqueCategoryIds.forEach(id => {
      formData.append("category_ids[]", String(id)); // number→string変換
    });
  }

  if (formModel.image_url === "") {
    formData.append("image", "");
  }
  if (get(inputUploadImage)?.files[0] != undefined) {
    formData.append("image", get(inputUploadImage)?.files[0]);
  }

  await MenuServices.saveMenu(
    { id: get(menuId), ...(await clinicIdParams()) } as ApiMenuShowReq,
    formData as unknown as ApiMenuSaveReq,
    onSuccess,
    onError
  );
};

/**
 * クリニックIDを取得する非同期関数。
 * @returns {Promise<ApiBaseReq>} クリニックIDを含むリクエストパラメータ
 */
const clinicIdParams = async (): Promise<ApiBaseReq> => ({ clinic_id: get(await get(clinicId)) });

/**
 * ルートパラメータからメニューIDをセットする。
 * @returns void
 */
const setMenuId = () => set(menuId, get(useRouteParams("id", 0, { route, router, transform: Number })));

/**
 * メニュー情報をAPIから取得する。
 * @returns Promise<void>
 */
const loadMenu = async (): Promise<void> => {
  const params = { id: get(menuId), ...(await clinicIdParams()) } as ApiMenuShowReq;
  const { data: menuData } = (await MenuServices.getMenu(params)) as unknown as AxiosResponse<IMenu>;
  set(menu, get(menuData));
};

/**
 * フォームモデルにAPIから取得したメニュー情報をセットする。
 * @returns Promise<void>
 */
const loadModel = async (): Promise<void> => {
  await loadMenu();
  const {
    id,
    name,
    description,
    visibility,
    display_price: displayPrice,
    time_unit: timeUnit,
    unit_price: unitPrice,
    room_ids: roomIds,
    medical_option_ids: optionIds,
    staff_ids: staffIds,
    multiple_tag_ids: multipleTagIds,
    single_tag_id: singleTagId,
    booking_type: bookingType,
    category_ids: categoryIds,
    position_number: positionNumber,
    image_url,
    notification_message: notificationMessage,
  } = get(menu) as IMenu;
  if (get(formModel).id == get(menuId)) return;

  Object.assign(formModel, {
    id,
    name,
    description,
    timeUnit,
    unitPrice,
    roomIds,
    optionIds,
    staffIds,
    multipleTagIds,
    singleTagId,
    bookingType,
    visibility,
    categoryIds: categoryIds || [],
    displayPrice,
    positionNumber,
    image_url,
    notificationMessage: notificationMessage || "",
  });

  if (formModel.timeUnit) {
    const calculatedHourValue = Math.floor(parseInt(formModel.timeUnit) / 60);
    const calculatedMinuteValue = parseInt(formModel.timeUnit) % 60;
    if (calculatedHourValue < 10) {
      set(formModel, "hourUnit", "0" + calculatedHourValue.toString());
    } else {
      set(formModel, "hourUnit", calculatedHourValue.toString());
    }
    if (calculatedMinuteValue === 0 || calculatedMinuteValue === 5) {
      set(formModel, "minuteUnit", "0" + calculatedMinuteValue.toString());
    } else {
      set(formModel, "minuteUnit", calculatedMinuteValue.toString());
    }
  }
};

/**
 * スタッフ一覧をAPIから取得する。
 * @returns Promise<void>
 */
const loadStaffs = async (): Promise<void> => {
  const params = { ...(await clinicIdParams()) } as ApiBaseReqParams;
  const { data } = (await StaffServices.getStaffs(params)) as unknown as AxiosResponse<ApiStaffIndexRes>;
  const { staffs: staffsData } = get(data);
  set(staffs, staffsData);
};

/**
 * オプション一覧をAPIから取得する。
 * @returns Promise<void>
 */
const loadMedicalOptions = async (): Promise<void> => {
  const params = { ...(await clinicIdParams()) } as ApiBaseReqParams;
  const { data } = (await MedicalOptionServices.getOptions(
    params,
    () => undefined,
    () => undefined
  )) as unknown as AxiosResponse<ApiMedicalOptionIndexRes>;
  const { options: optionsData } = get(data);
  set(options, optionsData);
};

/**
 * 部屋一覧をAPIから取得する。
 * @returns Promise<void>
 */
const loadRooms = async (): Promise<void> => {
  const params = { ...(await clinicIdParams()) } as ApiBaseReqParams;
  const { data } = (await RoomServices.fetchRooms(
    params,
    () => undefined,
    () => undefined,
    () => undefined
  )) as unknown as AxiosResponse<ApiRoomIndexReq>;
  const { rooms: roomsData } = get(data);
  set(rooms, roomsData);
};

/**
 * カテゴリー一覧をAPIから取得する。
 * @returns Promise<void>
 */
const loadCategories = async (): Promise<void> => {
  const params = { clinic_id: get(await get(clinicId)) };
  const { data } = await MedicalMenuCategoryServices.fetchCategories(
    params,
    () => undefined,
    () => undefined,
    () => undefined
  );
  if (data.value && data.value.categories) {
    set(categories, data.value.categories);
  } else {
    console.error("カテゴリーの取得に失敗しました");
    set(categories, []);
  }
};

/**
 * サービスタグ一覧をAPIから取得する。
 * @returns Promise<void>
 */
const loadServiceTags = async (): Promise<void> => {
  try {
    const params = { clinic_id: get(await get(clinicId)) };
    const { data } = await ServiceTagService.fetchServiceTag(params);
    const { service_tags: service_tags } = get(data);
    const singleTags = service_tags.filter(tag => +tag.selected_type == 1);
    set(singleSelectedTag, singleTags);
    const multipleTags = service_tags.filter(tag => +tag.selected_type == 2);
    set(multipleSelectedTag, multipleTags);
  } catch (error) {
    console.log("error", error);
  }
};

/**
 * フォーム初期化処理。各種データをロードする。
 * @returns Promise<void>
 */
const loadForm = async (): Promise<void> => {
  set(clinicId, await inject("clinicId"));
  await loadStaffs();
  await loadRooms();
  await loadMedicalOptions();
  await loadCategories();
  await loadServiceTags();

  if (!props.hasEdit) return;
  setMenuId();
  await loadModel();
};

/**
 * 画像を表示する。
 * @returns void
 */
const showImage = () => {
  let reader = new FileReader();
  reader.readAsDataURL(get(inputUploadImage).files[0]);
  reader.onload = evt => {
    let img: any | null = null;
    img = new Image();
    img.src = evt.target?.result;
  };
};

/**
 * 画像選択時の処理。
 * @param event ファイル選択イベント
 * @returns void
 */
const onSelectImage = (event: any) => {
  const file = event.originalEvent.target.files[0];
  if (file.size > 1000000) {
    notityErrorMsg(toast, "画像サイズが大きすぎます。1MB以下の画像を選択してください。");
  }
};

/**
 * マウント前にフォーム初期化処理を実行する。
 * @returns void
 */
onBeforeMount(() => loadForm());

// Watch formModel.hourUnit or formModel.hourUnit
/**
 * 時間単位の変更を監視し、timeUnitを再計算する。
 */
watch([() => formModel.hourUnit, () => formModel.minuteUnit], ([newHourUnit, newMinuteUnit]) => {
  const calculatedTimeUnit = parseInt(newHourUnit) * 60 + parseInt(newMinuteUnit);
  formModel.timeUnit = calculatedTimeUnit.toString();
  validate("timeUnit");
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      ref_key: "formRef",
      ref: formRef,
      class: "grid w-full mx-0",
      id: "medical-menu-form"
    }, [
      _createVNode(_component_InputText, {
        name: "clinic_id",
        class: "hidden",
        value: _unref(get)(clinicId.value)
      }, null, 8, ["value"]),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_InputText, {
          modelValue: formModel.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.name) = $event)),
          "aria-describedby": "name-help",
          type: "text",
          size: "large",
          name: "name",
          placeholder: "メニュー名",
          onInput: _cache[1] || (_cache[1] = ($event: any) => (validate('name'))),
          class: _normalizeClass(["w-6", { 'p-invalid': errorFields.value?.name }])
        }, null, 8, ["modelValue", "class"]),
        (errorFields.value?.name)
          ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(_.head(errorFields.value.name)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Textarea, {
          modelValue: formModel.description,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formModel.description) = $event)),
          "aria-describedby": "description-help",
          type: "text",
          size: "large",
          name: "description",
          rows: "5",
          cols: "30",
          maxlength: "150",
          placeholder: "説明が入ります (150字)",
          onInput: _cache[3] || (_cache[3] = ($event: any) => (validate('description'))),
          class: _normalizeClass(["w-6", { 'p-invalid': errorFields.value?.description }])
        }, null, 8, ["modelValue", "class"]),
        _createElementVNode("small", _hoisted_6, _toDisplayString(formModel.description?.length || 0) + "/150文字", 1),
        (errorFields.value?.description)
          ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_.head(errorFields.value.description)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_InputText, {
          modelValue: formModel.timeUnit,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formModel.timeUnit) = $event)),
          name: "time_unit",
          class: "hidden"
        }, null, 8, ["modelValue"]),
        _hoisted_9,
        _createVNode(_component_Dropdown, {
          modelValue: formModel.hourUnit,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formModel.hourUnit) = $event)),
          options: _unref(MedicalMenuHourOptions),
          optionLabel: "name",
          optionValue: "value",
          class: _normalizeClass(["mr-2 w-8rem font-normal", { 'p-invalid': errorFields.value?.timeUnit }]),
          onChange: _cache[6] || (_cache[6] = ($event: any) => (validate('timeUnit')))
        }, null, 8, ["modelValue", "options", "class"]),
        _createTextVNode(" : "),
        _createVNode(_component_Dropdown, {
          modelValue: formModel.minuteUnit,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formModel.minuteUnit) = $event)),
          options: _unref(MedicalMenuMinuteOptions),
          optionLabel: "name",
          optionValue: "value",
          class: _normalizeClass(["mr-2 ml-2 w-8rem font-normal", { 'p-invalid': errorFields.value?.timeUnit }]),
          onChange: _cache[8] || (_cache[8] = ($event: any) => (validate('timeUnit')))
        }, null, 8, ["modelValue", "options", "class"]),
        (errorFields.value?.timeUnit)
          ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_.head(errorFields.value.timeUnit)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_InputText, {
          modelValue: formModel.unitPrice,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formModel.unitPrice) = $event)),
          "aria-describedby": "time-unit-help",
          type: "text",
          size: "large",
          name: "unit_price",
          onInput: _cache[10] || (_cache[10] = ($event: any) => (validate('unitPrice'))),
          class: _normalizeClass(["w-2", { 'p-invalid': errorFields.value?.unitPrice }])
        }, null, 8, ["modelValue", "class"]),
        _hoisted_13,
        (errorFields.value?.unitPrice)
          ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(_.head(errorFields.value.unitPrice)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode(_component_InputText, {
          modelValue: formModel.positionNumber,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formModel.positionNumber) = $event)),
          "aria-describedby": "time-unit-help",
          type: "number",
          size: "large",
          min: 0,
          onInput: _cache[12] || (_cache[12] = ($event: any) => (validate('positionNumber'))),
          name: "position_number",
          class: "w-2"
        }, null, 8, ["modelValue"]),
        (errorFields.value?.positionNumber)
          ? (_openBlock(), _createElementBlock("small", _hoisted_17, _toDisplayString(_.head(errorFields.value.positionNumber)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _hoisted_20,
        _createVNode(_component_Textarea, {
          modelValue: formModel.notificationMessage,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formModel.notificationMessage) = $event)),
          "aria-describedby": "notification-message-help",
          type: "text",
          size: "large",
          name: "notification_message",
          rows: "3",
          cols: "30",
          maxlength: "500",
          placeholder: "このメニュー専用の通知メッセージを入力してください（任意）",
          onInput: _cache[14] || (_cache[14] = ($event: any) => (validate('notificationMessage'))),
          class: _normalizeClass(["w-6", { 'p-invalid': errorFields.value?.notificationMessage }])
        }, null, 8, ["modelValue", "class"]),
        _createElementVNode("small", _hoisted_21, _toDisplayString(formModel.notificationMessage?.length || 0) + "/500文字", 1),
        (errorFields.value?.notificationMessage)
          ? (_openBlock(), _createElementBlock("small", _hoisted_22, _toDisplayString(_.head(errorFields.value.notificationMessage)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          (formModel.image_url)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("img", {
                  role: "presentation",
                  src: formModel.image_url,
                  class: "my-1 px-2 h-10rem w-13rem",
                  style: {"object-fit":"contain"}
                }, null, 8, _hoisted_27),
                _createElementVNode("i", {
                  class: "pi pi-times-circle top-0 right-0 m-1 text-red-500 absolute",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (formModel.image_url = ''))
                })
              ]))
            : (_openBlock(), _createBlock(_unref(FileUpload), {
                key: 1,
                id: "upload",
                accept: "image/png, image/jpeg",
                ref_key: "inputUploadImage",
                ref: inputUploadImage,
                onChange: showImage,
                type: "file",
                fileLimit: 1,
                maxFileSize: 1000000,
                onSelect: onSelectImage
              }, {
                header: _withCtx(({ files, chooseCallback }) => [
                  _withDirectives(_createElementVNode("div", {
                    class: "h-10rem w-full align-items-center justify-content-center border-1 surface-border",
                    style: {"display":"flex"},
                    onClick: ($event: any) => (chooseCallback())
                  }, _hoisted_30, 8, _hoisted_28), [
                    [_vShow, files.length <= 0]
                  ])
                ]),
                content: _withCtx(({ files, removeFileCallback }) => [
                  _withDirectives(_createElementVNode("div", _hoisted_31, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files, (file, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: file.name + file.type + file.size,
                        class: "card relative border-1 surface-border"
                      }, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("img", {
                            role: "presentation",
                            alt: file.name,
                            src: file.objectURL,
                            class: "my-1 px-2 h-10rem w-13rem",
                            style: {"object-fit":"contain"}
                          }, null, 8, _hoisted_33)
                        ]),
                        _createElementVNode("i", {
                          class: "pi pi-times-circle top-0 right-0 m-1 text-red-500 absolute",
                          onClick: ($event: any) => (removeFileCallback(index))
                        }, null, 8, _hoisted_34)
                      ]))
                    }), 128))
                  ], 512), [
                    [_vShow, files.length > 0]
                  ])
                ]),
                _: 1
              }, 512))
        ]),
        (errorFields.value?.avatar)
          ? (_openBlock(), _createElementBlock("small", _hoisted_35, _toDisplayString(_.head(errorFields.value.avatar)?.message), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_unref(RadioButton), {
              modelValue: formModel.bookingType,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formModel.bookingType) = $event)),
              inputId: "regular-reservation",
              name: "booking_type",
              value: "normal"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", {
              for: "regular-reservation",
              class: _normalizeClass({ 'text-orange': formModel.bookingType == 'normal' })
            }, [
              _createElementVNode("div", _hoisted_39, [
                (formModel.bookingType == 'normal')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_40))
                  : (_openBlock(), _createElementBlock("span", _hoisted_41)),
                _createTextVNode(" 通常予約 ")
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_unref(RadioButton), {
              modelValue: formModel.bookingType,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formModel.bookingType) = $event)),
              inputId: "request-reservation",
              name: "booking_type",
              value: "request"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", {
              for: "request-reservation",
              class: _normalizeClass({ 'text-orange': formModel.bookingType == 'request' })
            }, [
              _createElementVNode("div", _hoisted_43, [
                (formModel.bookingType == 'request')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_44))
                  : (_openBlock(), _createElementBlock("span", _hoisted_45)),
                _createTextVNode(" リクエスト予約 ")
              ])
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createVNode(_unref(RadioButton), {
              modelValue: formModel.visibility,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formModel.visibility) = $event)),
              inputId: "public-reservation",
              name: "visibility",
              value: _unref(VISIBILITY_PUBLIC_STATUS)
            }, null, 8, ["modelValue", "value"]),
            _createElementVNode("label", {
              for: "public-reservation",
              class: _normalizeClass({ 'text-orange': formModel.visibility == _unref(VISIBILITY_PUBLIC_STATUS) })
            }, [
              _createElementVNode("div", _hoisted_49, [
                (formModel.visibility == _unref(VISIBILITY_PUBLIC_STATUS))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_50))
                  : (_openBlock(), _createElementBlock("span", _hoisted_51)),
                _createTextVNode(" 公開 ")
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_unref(RadioButton), {
              modelValue: formModel.visibility,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formModel.visibility) = $event)),
              inputId: "private-reservation",
              name: "visibility",
              value: _unref(VISIBILITY_PRIVATE_STATUS)
            }, null, 8, ["modelValue", "value"]),
            _createElementVNode("label", {
              for: "private-reservation",
              class: _normalizeClass({ 'text-orange': formModel.visibility == _unref(VISIBILITY_PRIVATE_STATUS) })
            }, [
              _createElementVNode("div", _hoisted_53, [
                (formModel.visibility == _unref(VISIBILITY_PRIVATE_STATUS))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_54))
                  : (_openBlock(), _createElementBlock("span", _hoisted_55)),
                _createTextVNode(" 非公開 ")
              ])
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createVNode(_unref(RadioButton), {
              modelValue: formModel.displayPrice,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formModel.displayPrice) = $event)),
              inputId: "display-price",
              name: "display_price",
              value: true
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", {
              for: "display-price",
              class: _normalizeClass({ 'text-orange': formModel.displayPrice })
            }, [
              _createElementVNode("div", _hoisted_59, [
                (formModel.displayPrice)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_60))
                  : (_openBlock(), _createElementBlock("span", _hoisted_61)),
                _createTextVNode(" 価格表示する ")
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createVNode(_unref(RadioButton), {
              modelValue: formModel.displayPrice,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formModel.displayPrice) = $event)),
              inputId: "hide-price",
              name: "display_price",
              value: false
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", {
              for: "hide-price",
              class: _normalizeClass({ 'text-orange': !formModel.displayPrice })
            }, [
              _createElementVNode("div", _hoisted_63, [
                (!formModel.displayPrice)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_64))
                  : (_openBlock(), _createElementBlock("span", _hoisted_65)),
                _createTextVNode(" 価格表示しない ")
              ])
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_66, [
        _hoisted_67,
        _createElementVNode("div", _hoisted_68, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "field-checkbox col-4",
              key: category.id
            }, [
              _createVNode(_component_Checkbox, {
                modelValue: formModel.categoryIds,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formModel.categoryIds) = $event)),
                inputId: 'category-' + category.id,
                name: "category_ids[]",
                value: category.id,
                class: "checkbox"
              }, null, 8, ["modelValue", "inputId", "value"]),
              _createElementVNode("label", {
                for: 'category-' + category.id,
                class: "text-700 ml-1"
              }, _toDisplayString(category.name), 9, _hoisted_69)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_70, [
        _hoisted_71,
        _createElementVNode("div", _hoisted_72, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rooms.value, ({ id: roomId, name: roomName }) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "field-checkbox col-4",
              key: roomId
            }, [
              _createVNode(_component_Checkbox, {
                modelValue: formModel.roomIds,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formModel.roomIds) = $event)),
                inputId: `checkbox-rooms-${roomId}`,
                name: "room_ids[]",
                value: roomId,
                class: "checkbox"
              }, null, 8, ["modelValue", "inputId", "value"]),
              _createElementVNode("label", {
                for: `checkbox-rooms-${roomId}`,
                class: "text-700 ml-1"
              }, _toDisplayString(roomName), 9, _hoisted_73)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_74, [
        _hoisted_75,
        _createElementVNode("div", _hoisted_76, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, ({ id: optionId, name: optionName }) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "field-checkbox col-4",
              key: optionId
            }, [
              _createVNode(_component_Checkbox, {
                modelValue: formModel.optionIds,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formModel.optionIds) = $event)),
                inputId: `checkbox-options-${optionId}`,
                name: "medical_option_ids[]",
                value: optionId,
                class: "checkbox"
              }, null, 8, ["modelValue", "inputId", "value"]),
              _createElementVNode("label", {
                for: `checkbox-options-${optionId}`,
                class: "text-700 ml-1"
              }, _toDisplayString(optionName), 9, _hoisted_77)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_78, [
        _hoisted_79,
        _createElementVNode("div", _hoisted_80, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(staffs.value, ({ id: staffId, name_kanji: staffName }) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "field-checkbox col-4",
              key: staffId
            }, [
              _createVNode(_component_Checkbox, {
                modelValue: formModel.staffIds,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((formModel.staffIds) = $event)),
                inputId: `checkbox-staffs-${staffId}`,
                name: "staff_ids[]",
                value: staffId,
                class: "checkbox",
                onChange: _cache[26] || (_cache[26] = ($event: any) => (validate('staffIds')))
              }, null, 8, ["modelValue", "inputId", "value"]),
              _createElementVNode("label", {
                for: `checkbox-staffs-${staffId}`,
                class: "text-700 ml-1"
              }, _toDisplayString(staffName), 9, _hoisted_81)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_82, [
        _hoisted_83,
        _createElementVNode("div", _hoisted_84, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(multipleSelectedTag.value, ({ id: tagId, name: tagName, color: tagColor }) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "field-checkbox col-4 mb-0",
              key: tagId
            }, [
              _createElementVNode("div", _hoisted_85, [
                _createVNode(_component_Checkbox, {
                  modelValue: formModel.multipleTagIds,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((formModel.multipleTagIds) = $event)),
                  inputId: `checkbox-service-tag-${tagId}`,
                  name: "multiple_tag_ids[]",
                  value: tagId,
                  class: "checkbox"
                }, null, 8, ["modelValue", "inputId", "value"]),
                _createElementVNode("label", {
                  for: `checkbox-service-tag-${tagId}`,
                  class: "select-none ml-2 px-3 py-1 border-round-lg text-center text-white text-sm font-medium cursor-pointer",
                  style: _normalizeStyle([{ 'background-color': tagColor }])
                }, [
                  _createElementVNode("span", null, _toDisplayString(tagName), 1)
                ], 12, _hoisted_86)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_87, [
        _hoisted_88,
        _createElementVNode("div", _hoisted_89, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singleSelectedTag.value, ({ id: tagId, name: tagName, color: tagColor }) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "radio-wrapper__custom field-checkbox col-4 mb-0",
              key: tagId
            }, [
              _createVNode(_unref(RadioButton), {
                modelValue: formModel.singleTagId,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((formModel.singleTagId) = $event)),
                inputId: `tag-${tagId}`,
                name: "single_tag_id",
                value: +tagId
              }, null, 8, ["modelValue", "inputId", "value"]),
              _createElementVNode("label", {
                for: `tag-${tagId}`,
                class: _normalizeClass(["flex align-items-center ml-0 py-2 cursor-pointer", { 'text-orange': +formModel.singleTagId == +tagId }])
              }, [
                (+formModel.singleTagId == +tagId)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_91))
                  : (_openBlock(), _createElementBlock("span", _hoisted_92)),
                _createElementVNode("div", {
                  style: _normalizeStyle([{ 'background-color': tagColor }]),
                  class: "px-3 py-2 border-round-lg text-center text-white text-sm font-medium"
                }, _toDisplayString(tagName), 5)
              ], 10, _hoisted_90)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_93, [
          _createVNode(_unref(RadioButton), {
            modelValue: formModel.singleTagId,
            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((formModel.singleTagId) = $event)),
            inputId: "none",
            name: "single_tag_id",
            value: ""
          }, null, 8, ["modelValue"]),
          _createElementVNode("label", {
            for: "none",
            class: _normalizeClass(["flex align-items-center ml-0 cursor-pointer", { 'text-orange': !formModel.singleTagId }])
          }, [
            (!formModel.singleTagId)
              ? (_openBlock(), _createElementBlock("span", _hoisted_94))
              : (_openBlock(), _createElementBlock("span", _hoisted_95)),
            _hoisted_96
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_97, [
        _createVNode(_component_Button, {
          type: "button",
          class: "p-button-light mb-8 mr-5",
          onClick: backToList,
          label: "キャンセル"
        }),
        _createVNode(_component_Button, {
          type: "button",
          class: "btn-primary btn-save mb-8 w-3",
          onClick: saveModel,
          label: "保存する"
        })
      ])
    ], 512),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})